import './app.less';

import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import Globalize from 'globalize';
import SearchElementController from './layout/SearchElementController';
import NavigationElementController from './layout/NavigationElementController';
import CategoryMenuElementController from './layout/CategoryMenuElementController';
import BreadcrumbElementController from './layout/BreadcrumbElementController';
import ProductComparisonElementController from './catalog/ProductComparisonElementController';
import ShoppingCartElementController from './shoppingCart/ShoppingCartElementController';
import '../jquery/jquery.labelToPlaceholder';
import '../jquery/jquery.selectOnFocus';

export default Backbone.View.extend({

    ajaxLoaderTimeout: null,

    events: {
        'hide.bs.modal #product-comparison-modal': 'onHideCompareModal',
        'hide.bs.modal #customer-order-number': 'onHideFastPurchase',
        'keyup #categorySearch': 'searchFilter',
        scroll: 'hideCalendar',
        keydown: 'hideCalendar'
    },

    initialize: function () {
        this.initPageHeaderSearchForm();
        this.initAjaxHandlers();
    },


    initPageHeaderSearchForm: function () {
        const input = $('article > header.search-form > form > input');

        // set labels as placeholders
        input.labelToPlaceholder();

        // auto-select value on focus
        input.selectOnFocus();
    },

    // initializes several partials (partial views) of the layout
    initPartials: function () {
        const search = this.$('#header-search');
        const shoppingCartStatus = this.$('#header-shoppingCart');
        const productComparisonStatus = $.Mustache.jQ('header-productComparison-status');

        this.$('#comparisionList-anchor')
            .removeClass('offset1')
            .before(productComparisonStatus);

        // layout header
        this.header = {
            search: (search.length > 0) ? new SearchElementController({ el: search }) : null,
            productComparison: (productComparisonStatus.length > 0) ? new ProductComparisonElementController({ el: productComparisonStatus }) : null,
            shoppingCart: (shoppingCartStatus.length > 0) ? new ShoppingCartElementController({ el: shoppingCartStatus }) : null
        };

        // global navigation bar
        this.navigation = (this.$('nav.navbar').length > 0) ? new NavigationElementController({ el: this.$('nav.navbar') }) : null;

        // category menu
        this.categoryMenu = (this.$('#wrapper > .category-menu').length > 0) ? new CategoryMenuElementController({ el: this.$('#wrapper > .category-menu') }) : null;

        // breadcrumbs
        this.breadcrumb = (this.$('#breadcrumb').length > 0) ? new BreadcrumbElementController({ el: this.$('#breadcrumb') }) : null;
    },


    // initializes AJAX handlers for displaying loading and error indicators
    initAjaxHandlers: function () {
        // use $.proxy which takes a function and returns a new one that will always have the given context
        $(document).bind('ajaxStart', $.proxy(this.showAjaxLoader, this));
        $(document).bind('ajaxStop', $.proxy(this.hideAjaxLoader, this));
        $(document).bind('ajaxError', $.proxy(this.handleError, this));
    },


    // default error handler for AJAX calls
    handleError: function (event, jqxhr, settings) {
        // let's see if the server returned an JSON error object as it should do
        let error;
        try {
            error = $.parseJSON(jqxhr.responseText);

        // if that fails...
        } catch (exception) {
            // request was redirected to login page which mean's the user's session has expired
            const loginView = $(jqxhr.responseText).find('article.login-login');
            if (loginView.length > 0) {
                this.showSessionExpirationNotification();
                this.hideAjaxLoader();
                return;

            // create a new error object from AJAX request
            }
            error = {
                status: jqxhr.status,
                code: jqxhr.status,
                message: jqxhr.statusText,
                developerMessage: jqxhr.statusText
            };

        }

        // when leaving the page during an AJAX call, error might be null
        if (error !== null) {
            // use the given error message by default
            let errorMessage = error.message;

            // for general errors (meaning that there is no P!ONE specific error code), display a generic error
            if (!_.isUndefined(error.code) && (error.code === 400 || error.code === 500)) {
                errorMessage = Globalize.localize(`error.http.${error.code}`);
            }

            this.showAjaxError(errorMessage);
        }
    },


    // displays loading indicator for AJAX calls
    showAjaxLoader: function () {
        this.ajaxLoaderTimeout = setTimeout(() => {
            this.hideAjaxError();

            const ajaxLoader = $.Mustache.jQ('ajax-notification', {
                text: Globalize.localize('general.loading')
            });

            ajaxLoader.addClass('ajax-loader');

            ajaxLoader.appendTo($('body'));
            ajaxLoader.fadeIn('fast');
        }, 500);
    },


    // hides loading indicator for AJAX calls
    hideAjaxLoader: function () {
        if (this.ajaxLoaderTimeout !== null) {
            clearTimeout(this.ajaxLoaderTimeout);
        }

        $('.ajax-loader').fadeOut('fast', () => $('.ajax-loader').remove());
    },


    // default method for displaying an AJAX error notification
    showAjaxError: function (text) {
        const ajaxError = $.Mustache.jQ('ajax-notification', {
            text: text
        });

        ajaxError.addClass('ajax-error');
        ajaxError.attr('role', 'alert');
        ajaxError.appendTo($('body'));
        ajaxError.fadeIn('fast');

        setTimeout(_.bind(this.hideAjaxError, this), 5000);
    },


    // hides the AJAX error notification
    hideAjaxError: function () {
        $('.ajax-error').fadeOut('fast', () => $('.ajax-error').remove());
    },


    // the default AJAX error notification can be suppressed using this method,
    // if for example a customized way to handle AJAX errors was implemented
    suppressAjaxError: function () {
        $('.ajax-error').remove();
    },


    // displays a notification if the session has expired and the user has been logged out
    showSessionExpirationNotification: function () {

        // make sure that this modal is the only one
        $('body > .modal, body > .modal-backdrop').remove();

        // show the notification modal
        const sessionExpirationNotification = $.Mustache.jQ('session-expiration-notification');
        sessionExpirationNotification.modal();

        // instead of redirecting directly to the login page we make a page refresh so that the user returns to the current page after login

        // button click
        sessionExpirationNotification.find('.btn-primary').click(_.bind((event) => {
            event.preventDefault();
            window.location.reload();
        }, this));

        // other ways of hiding the notification
        sessionExpirationNotification.on('hide', _.bind(() => {
            window.location.reload();
        }, this));
    },

    onHideCompareModal: function () {
        setTimeout(function () {
            document.getElementById('header-productComparisonLink').focus();
        }, 0);
    },

    onHideFastPurchase: function () {
        setTimeout(function () {
            document.getElementById('header-shoppingCartLink').focus();
        }, 0);
    },

    searchFilter: function () {
        const input = document.getElementById('categorySearch');
        const filter = input.value.toUpperCase();
        const div = document.getElementById('categoryDropdownMenu');
        const aTag = div.getElementsByTagName('a');
        let count = 0;

        for (count; count < aTag.length; count = count + 1) {
            const txtValue = aTag[count].textContent || aTag[count].innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                aTag[count].style.display = '';
            } else {
                aTag[count].style.display = 'none';
            }
        }
    },

    hideCalendar: function (event) {
        $(document).ready(function () {
            const keyCode = event.keyCode || event.which;
            if (!((keyCode > 47 && keyCode < 58) || keyCode === 190 || (keyCode > 95 && keyCode < 106))) {
                $('#ui-datepicker-div').hide();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./views/AppController.js